import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { path: '/email-campaigns/events', label: 'Events' },
  { path: '/email-campaigns/templates', label: 'Templates' },
  { path: '/email-campaigns/scheduler', label: 'Scheduler' },
  { path: '/email-campaigns/logs', label: 'Email Logs' },
];

const EmailCampaignsNav = () => {
  const location = useLocation();

  return (
    <div className="flex gap-1 bg-gray-100 dark:bg-dark-700 p-1 rounded-xl w-fit flex-wrap">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              isActive
                ? 'bg-white dark:bg-dark-800 text-primary-600 shadow-sm'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default EmailCampaignsNav;
